<template>
  <div class="history" v-resize="setSplitFlg">
    <v-base-card>
      <template v-slot:heading>
        {{$store.state.school.name}} 申し込み一覧
      </template>

      <template v-slot:content>
        <!-- width=1219以下の場合、表示を２段に変更する -->
        <v-row class="mb-0 pb-0">

          <v-col :cols="splitFlg ? 4 : 2" :class="splitFlg ? 'pb-0' : ''">
            <v-select
              v-model="selectedGradeName"
              :items="grades.map(grade => grade.name)"
              label="学年"
              clearable
            ></v-select>
          </v-col>

          <v-col :cols="splitFlg ? 4 : 2" :class="splitFlg ? 'pb-0' : ''">
            <v-select
              v-model="selectedSubjectName"
              :items="subjects.map(subject => subject.name)"
              label="教科"
              clearable
            ></v-select>
          </v-col>

          <!-- width=1219以下の場合「PDFダウンロード」ボタンのみ位置を変更するためv-ifで対応 -->
          <v-col cols="4" v-if="splitFlg" class="pb-0">
            <v-btn
              class="mt-5 ml-auto"
              small
              color="#4a81aa"
              :dark="pdfDlFlg"
              @click.stop="pdfDownload"
              :disabled="!pdfDlFlg"
            >
              PDFダウンロード
            </v-btn>
            <v-btn
              class="mt-5 ml-3"
              small
              color="#4a81aa"
              :dark="pdfDlFlg"
              @click.stop="csvDownload"
              :disabled="!pdfDlFlg"
            >
              一覧表出力
            </v-btn>
          </v-col>

          <v-col :cols="splitFlg ? 4 : 2" :class="splitFlg ? 'pt-0' : ''">
            <v-menu
              ref="startMenu"
              v-model="startMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDateText"
                  label="申込開始日"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
              />
            </v-menu>
          </v-col>

          <v-col :cols="splitFlg ? 4 : 2" :class="splitFlg ? 'pt-0' : ''">
            <v-menu
              ref="endMenu"
              v-model="endMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDateText"
                  label="申込終了日"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                no-title
              />
            </v-menu>
          </v-col>

          <v-col :cols="splitFlg ? 4 : 3" :class="splitFlg ? 'pt-0' : ''">
            <v-select
              v-model="selectedStatusName"
              :items="statuses.map(status => status.name)"
              label="ステータス"
            ></v-select>
          </v-col>

          <!-- width=1219以下の場合「PDFダウンロード」ボタンのみ位置を変更するためv-ifで対応 -->
          <v-col cols="4" v-if="!splitFlg">
            <v-btn
              class="mt-5 ml-auto"
              small
              color="#4a81aa"
              :dark="pdfDlFlg"
              @click.stop="pdfDownload"
              :disabled="!pdfDlFlg"
            >
              PDFダウンロード
            </v-btn>
            <v-btn
              class="mt-5 ml-3"
              small
              color="#4a81aa"
              :dark="pdfDlFlg"
              @click.stop="csvDownload"
              :disabled="!pdfDlFlg"
            >
              一覧表出力
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="filterdApplications"
          v-model="selectedApplications"
          show-select
          :loading="loading"
          loading-text="Loading... Please wait"
          :options.sync="pagination"
          :height="300"
          hide-default-footer
        >
          <template #[`item.data-table-select`]="{ isSelected, select, item }">
            <v-simple-checkbox
              v-if="item.status_i18n !== '取消'"
              :value="isSelected"
              @input="select($event)"
              :ripple="false"
            />
          </template>
          <template #[`item.subject_name`]="{ item }">
            <v-subject-chip
              :type="subjects.find(subject => subject.name === item.subject_name).code"
            >
              {{ item.subject_name }}
            </v-subject-chip>
          </template>
          <template #[`item.status_i18n`]="{ item }">
            <v-chip dark class="my-1 mx-2"
              :class="getStatusClass(statuses.find(s => s.name === item.status_i18n).code)"
            >
              {{item.status_i18n}}
            </v-chip>
          </template>
          <template #[`item.delete`]="{ item }">
            <v-btn
              v-if="item.status_i18n !== '取消'"
              icon
              @click.stop="openDeleteConfirmDialog(item)"
            >
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template #[`item.details`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="showDetail(item)">
              確認
            </v-btn>
          </template>
          <template #[`item.preview`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="showPhotoSwipe(item)">
              確認
            </v-btn>
          </template>
          <template #[`item.export`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="saitenExcelDownload(item)">
              出力
            </v-btn>
          </template>
          <template #[`item.recompose`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="handleToRecompose(item)">
              再組版
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="pagination.page"
          :length="pages"
          color="secondary"
        />
      </template>
    </v-base-card>

    <v-confirm-dialog
      ref="confirm"
      title="申込取り消し"
      :message="deleteMessage"
      buttonMessage="取消"
      @confirm="confirmDeletion"
    />

    <v-photo-swipe
      :isOpen="isOpenPhotoSwipe"
      :items="photoSwipeItems"
      :options="photoswipeOptions"
      @close="hidePhotoSwipe" />

    <v-dialog
      v-if="selectedHistory"
      v-model="detailDialog"
      persistent
      max-width="400px"
    >
      <v-card
        min-height="150px"
      >
        <v-toolbar
          class="title"
        >{{selectedHistory.grade_name}} {{selectedHistory.subject_name}}</v-toolbar>

        <v-card-text class="px-5">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left pl-1 py-2 th_top">大問番号</th>
                  <th class="text-left pl-1 py-2 th_top">大問管理番号</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="content in selectedHistory.sheet_content_pages" :key="content.number">
                  <td class="text-left pl-1 py-2 td_top">{{content.number}}</td>
                  <td class="text-left pl-1 py-2 td_top">{{content.content_short_code}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions class="card-action">
          <v-spacer></v-spacer>
          <v-btn color="gray" class="dialog-Button" @click="detailDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSubjectChip from '@/components/atoms/SubjectChip'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
    VSubjectChip,
    VConfirmDialog,
    VPhotoSwipe,
  },
  data () {
    return {
      isOpenPhotoSwipe: false,
      startMenu: false,
      endMenu: false,
      startDate: null,
      endDate: null,
      photoSwipeItems: [],
      headers: [
        { text: '発行コード', align: 'start', value: 'code' },
        { text: 'ログインID', align: 'start', value: 'login' },
        { text: '学年', align: 'center', value: 'grade_name' },
        { text: '教科', align: 'center', value: 'subject_name' },
        { text: '試験名', align: 'center', value: 'sheet_name' },
        { text: '申込日時', align: 'center', value: 'created_at' },
        { text: '実施日', align: 'center', value: 'implementation_date' },
        { text: 'ステータス', align: 'center', value: 'status_i18n' },
        { text: '問題内容', align: 'center', value: 'details', sortable: false },
        { text: 'プレビュー', align: 'center', value: 'preview' },
        { text: '観点別集計表', align: 'center', value: 'export' },
        { text: '再組版', align: 'center', value: 'recompose' },
        { text: '取消', align: 'center', value: 'delete', sortable: false },
      ],
      applications: [],
      selectedApplications: [],
      selectedGradeName: null,
      selectedSubjectName: null,
      selectedStatusName: '未処理 or 内容確認中',
      statuses: [
        { code: null, name: '全て' },
        { code: 'not-done', name: '未処理' },
        { code: 'processing', name: '内容確認中' },
        { code: 'not-done_processing', name: '未処理 or 内容確認中' },
        { code: 'done', name: '処理済み' },
        { code: 'delete', name: '取消' },
        { code: 'demo', name: 'お試し利用' },
      ],
      deletedApplication: {
        id: null,
        code: '',
        sheet_name: '',
      },
      loading: false,
      pagination: {
        itemsPerPage: 5
      },
      photoswipeOptions: {
        index: 0,
      },
      detailDialog: false,
      selectedHistory: null,
      splitFlg: window.innerWidth < 1220
    }
  },

  async mounted() {
    await this.getApplications()
  },

  computed: {
    subjects() {
      return this.$store.getters['master/subjectBases']
    },
    grades() {
      return this.$store.state.master.allGrades
    },
    filterdApplications() {
      return this.applications
        .filter(application => {
          if (!this.selectedGradeName) return application
          return application.grade_name === this.selectedGradeName
        }).filter(application => {
          if (!this.selectedSubjectName) return application
          return application.subject_name === this.selectedSubjectName
        })
        .filter(application => {
          if (!this.startDate) return application
          return this.startDateText <= application.created_at.substr(0,10)
        })
        .filter(application => {
          if (!this.endDate) return application
          return this.endDateText >= application.created_at.substr(0,10)
        })
        .filter(application => {
          if (!this.selectedStatusName || this.selectedStatusName === '全て') return application
          return this.selectedStatusName.includes(application.status_i18n)
        })
    },
    startDateText: {
      get() {
        return this.formatDate(this.startDate)
      },
      set() {
        this.startDate = null
      }
    },
    endDateText: {
      get() {
        return this.formatDate(this.endDate)
      },
      set() {
        this.endDate = null
      }
    },
    deleteMessage() {
      return `${this.deletedApplication.code} ${this.deletedApplication.sheet_name} を取消します。よろしいですか。`
    },
    pages() {
      return this.pagination.itemsPerPage ? Math.ceil(this.filterdApplications.length / this.pagination.itemsPerPage) : 0
    },
    pdfDlFlg() {
      const array = this.selectedApplications.map(selectedApplication=> {
        if (selectedApplication.status_i18n==='取消') return false
        return this.filterdApplications.map(x=>x.id).includes(selectedApplication.id)
      })
      return array.includes(true)
    }
  },

  methods: {
    setSplitFlg() {
      this.splitFlg = window.innerWidth < 1220 //width=1219以下で「申込開始...」「申込終了...」と崩れるので表示を２段に変更する
    },
    hasScriptImage(sheetContentPages) {
      return sheetContentPages.map(scp => scp.has_script_image).includes(true)
    },
    getStatusClass(status) {
      let className = 'chip__status'
      if (status === 'not-done') return className + '-applicate'
      else if (status === 'done') return className + '-contracted'
      else if (status === 'delete') return className + '-deleted'
      else if (status === 'processing') return className + '-processing'
      else if (status === 'demo') return className + '-demo'
      else return className + '-shipped'
    },
    showPhotoSwipe(application) {
      this.photoSwipeItems = application.file_paths.map(path => {
        return { src: this.$axios.defaults.baseURL + path, w: 900, h: 600 }
      })
      this.isOpenPhotoSwipe = true;
    },
    hidePhotoSwipe(){
      this.isOpenPhotoSwipe = false
    },
    // 申し込み一覧取得API
    async getApplications() {
      this.loading = true
      const res = await this.$axios((
        `/api/v1/admin/requests?q[sheet_subject_teacher_user_school_id_eq]=${this.$route.params.school_id}`
      ))
      this.applications = res.data
      this.loading = false
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    openDeleteConfirmDialog(application) {
      this.deletedApplication = application
      this.$refs.confirm.open()
    },
    // 申し込み取消API
    async confirmDeletion() {
      const url = `api/v1/admin/requests/${this.deletedApplication.id}`
      await this.$axios.put(url, {
        request: {status: 'deletion'}
      })
      this.$toasted.global.success({
        message: `${this.deletedApplication.code} ${this.deletedApplication.sheet_name}を取消しました`
      })
      this.getApplications()
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
    async pdfDownload(){
      //全チェックした場合、取消の申込もDLされてしまうためフィルタリング
      const ids = this.selectedApplications.filter(selectedApplication=>selectedApplication.status_i18n!=='取消').map(app => app.id)
      this.selectedApplications = [] //パラメータ作成したら選択をリセット
      const res = await this.$axios.get(`/api/v1/admin/requests/pdf_download`, {
        params: { ids: ids },
         responseType: 'blob',
         dataType: 'binary',
      })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.getApplications()
    },

    async csvDownload(){
      //内容確認以外はエラー
      // if(this.selectedApplications.some(selectedApplication => selectedApplication.status_i18n!=='取消' && selectedApplication.status_i18n!=='内容確認中')){
      //   this.$toasted.global.error({ message: 'ステータスが内容確認中以外は選択できません。' })
      //   return
      // }

      //全チェックした場合、取消の申込もDLされてしまうためフィルタリング
      const ids = this.selectedApplications.filter(selectedApplication=>selectedApplication.status_i18n!=='取消').map(app => app.id)

      this.selectedApplications = [] //パラメータ作成したら選択をリセット
      const res = await this.$axios.get(`/api/v1/admin/requests/csv_download.csv`, {
        params: { ids: ids },
         responseType: 'blob',
      })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.getApplications()
    },

    showDetail(item){
      this.detailDialog = true
      this.selectedHistory = item
    },

    async saitenExcelDownload(application) {
      const res = await this.$axios.get(`/api/v1/admin/requests/${application.id}/saiten_excel_download.xlsx`, {
        responseType: 'blob',
      })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
    },

    handleToRecompose(item){
      this.$router.push(`/admin/recompose/${item.code}`)
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;

.chip
  &__status
    &-applicate
      background-color #3E90C6 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #c4c4c4
      display inline-block

    &-contracted
      background-color #4caf50 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #337f36
      display inline-block

    &-deleted
      background-color #808080 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #696767
      display inline-block

    &-shipped
      background-color #8e8e8e !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #6d6464
      display inline-block

    &-processing
      background-color #c44c32 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #8a1c1c
      display inline-block

    &-demo
      background-color: #808080 !important;
      width: 104px;
      height: 19px !important;
      font-size: 10px !important;
      font-weight: bold;
      border-bottom: 1px solid #121212;
      display: inline-block;

.title
  justify-content center
  background-color: #2a5594 !important
  color white

</style>
